import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";

import Header from "../../Global/Header";
import { withRouter } from "react-router";

const ResultExam = (props) => {
  const [state, setState] = useState({
    quizResault: JSON.parse(localStorage.getItem("QuizResault")),
    loading: false,
  });

  useEffect(() => {
    setState({
      ...state,
      quizResault: JSON.parse(localStorage.getItem("QuizResault")),
    });
    setTimeout(() => {
      setState({
        ...state,
        loading: true,
      });
    }, 300);
    localStorage.removeItem("QuizResault");
  }, []);
  console.log(state);
  return (
    <div className={`instructpg resault-quiz ${state.loading ? "active" : ""}`}>
      <Header innerPage={true} title={"نتیجه آزمون"} />
      <div className="reaultquz">
        {state.quizResault == null ? (
          ""
        ) : state.quizResault.exam_passed == 1 ? (
          <img src="/img/certificate.gif" />
        ) : (
          <img src="/img/failed.gif" />
        )}
        <span>
          {state.quizResault == null
            ? ""
            : state.quizResault.result_description}
        </span>
        <div className="box-reslt">
          {state.quizResault.exam_passed === -1 ? (
            <span>
              {" "}
              آزمون شما به‌پایان رسید، پس از اصلاح آزمون نمره شما گزارش داده می
              شود
            </span>
          ) : (
            <>
              <span>جزيیات آزمون</span>
              <strong>تعداد کل سوالات</strong>
              <b>
                {state.quizResault == null
                  ? ""
                  : state.quizResault.total_questions_count}
              </b>
              <div className="row-question">
                <div className="aswer-qustion">
                  <i className="icon-18609881301579252554"></i>
                  <span>تعداد سوالات درست</span>
                  <b>
                    {state.quizResault == null
                      ? ""
                      : state.quizResault.right_answers_count}
                  </b>
                </div>
                <div className="aswer-qustion">
                  <i className="icon-18609881301579252554"></i>
                  <span>تعداد سوالات نادرست</span>
                  <b>
                    {state.quizResault == null
                      ? ""
                      : state.quizResault.wrong_answers_count}
                  </b>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="btn-base btn-black btn-sircle">
          {state.quizResault.certificate_url === "" ? (
            <div className="haveCertificate">
              شما قبلا برای این آزمون گواهینامه دریافت کرده اید.
            </div>
          ) : state.quizResault == null ? (
            ""
          ) : state.quizResault.exam_passed !== -1 ? (
            <a
              download
              href={
                state.quizResault == null
                  ? ""
                  : state.quizResault.certificate_url
              }
            >
              دانلود گواهینامه
            </a>
          ) : (
            <Button variant="contained" onClick={() => props.history.goBack()}>
              شروع مجدد آزمون
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(ResultExam);
